<div class="d-flex flex-row align-items-center security-index-item">
  <div class="security-index-name">{{item?.properName}}</div>
  <div *ngIf="item?.tickerRegion" class="ml-1 security-index-ticker">{{ "(" +
    item?.tickerRegion.split("-")[0] + ")"}}</div>
  <div *ngIf="item?.exchangeDescription" class="ml-1 security-index-exchange">{{item?.exchangeDescription}}
  </div>
  <div *ngIf="item?.tickerRegion" class="ml-1 security-index-exchange-country">
    {{countryIsoCodeToName(item?.tickerRegion.split("-")[1], 'en')}}</div>
  <div *ngIf="item?.companyId" class="security-index-from-racap">
    <img src="assets/images/ra-blue.png" alt="RA Capital" class="ra-cap-icon"/>
    <span>ID: {{item?.companyId}}</span>
  </div>
  <div *ngIf="!item?.companyId" class="security-index-from-factset">
    <img  src="assets/icons/factset-f.svg" alt="Factset" class="factset-icon"/>
  </div>
</div>
